import { Profil } from "./profil.interface";

// Défini une entité contenant des Profils et des Patients.
export interface Cabinet {
  id: string;
  nom: string;
  adresse: string;
  codePostal: string;
  ville: string;
  type: string;
  emailAdmin?: string;
  disabled: boolean;
  profils?: Profil[]
  etatDeploiement?: EtatDeploiementEnum;
  certificatDmpExists?: boolean;
  certificatInsiExists?: boolean;
  qtyProfils?: number;
  qtyProfilsActifs?: number;
}

export enum EtatDeploiementEnum {
  NonDeploye = "non_deploye",
  EnCours = "en_cours",
  Deploye = "deploye",
  Erreur = "erreur",
}
